import { render, staticRenderFns } from "./RiskTextMain.vue?vue&type=template&id=776245b1&"
import script from "./RiskTextMain.vue?vue&type=script&lang=js&"
export * from "./RiskTextMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports